import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: "app-image-upload",
    templateUrl: "./image-upload.component.html",
    styleUrls: ["./image-upload.component.scss"]
})
export class ImageUploadComponent {
    // message to display below the drag-and-drop area
    @Input() message;

    // accepted file mime types
    @Input() accept = "*";

    // shape of the drag-and-drop area
    @Input() shape: "circle" | "square" = "square";

    // emits when file upload is finished and when file is canceled
    // emits an object with two properties
    // file - File object
    // picture - uploaded picture buffer
    // when file is canceled, both properties of emitted object are null
    @Output() fileInput: EventEmitter<{
        file: File;
        picture: ArrayBuffer;
    }> = new EventEmitter();

    file: File = null;
    picture: any = null;
    isLoading = false;

    onFileSelected(event) {
        this.isLoading = true;
        this.file = event;
        const reader = new FileReader();
        reader.onload = e => {
            this.picture = reader.result;
            this.isLoading = false;
            this.emitChanges();
        };
        reader.onabort = e => {
            this.isLoading = false;
        };
        reader.onerror = e => {
            this.isLoading = false;
        };
        reader.readAsDataURL(event);
    }

    onCancel(event) {
        event.stopPropagation();
        event.preventDefault();
        this.file = null;
        this.picture = null;
        this.emitChanges();
    }

    emitChanges() {
        this.fileInput.emit({ file: this.file, picture: this.picture });
    }
}
